import intlTelInput from "intl-tel-input";
import Filter from "bad-words";
import toastr from "toastr";
import axios from "axios";
import $ from "jquery";
require('jquery.rateit');

$(function(){

  /**
   * add country flags and country codes on input for mobile on contact form 1
   * @type {Element}
   */
  const contactForm1Mobile = document.getElementById("contactForm1Mobile");

  if(contactForm1Mobile !== null){
    intlTelInput(contactForm1Mobile, {
      initialCountry: "in",
      separateDialCode: true,
      nationalMode: true
    });
  }

  const contactPhonePage = document.getElementById("contactPhonePage");

  if(contactPhonePage !== null){
    intlTelInput(contactPhonePage, {
      initialCountry: "in",
      separateDialCode: true,
      nationalMode: true
    });
  }

  $('#contactForm1').on('submit', function(e){
    e.preventDefault();
    const FORM = $(this);
    const SUBMIT_BUTTON = FORM.find('[type="submit"]');
    const FORM_DATA = new FormData(this);
    let errorCounter = 0;
    FORM_DATA.append('country_code', FORM.find('.iti__selected-dial-code').text());

    if(FORM_DATA.get('name').length < 3){
      FORM.find('[name=name]').next().next().text('invalid name');
      errorCounter++;
    }else{
      FORM.find('[name=name]').next().next().text('');
    }

    if(validateEmail(FORM_DATA.get('email')) === false){
      FORM.find('[type=email]').next().text('invalid email');
      errorCounter++;
    }else{
      FORM.find('[type=email]').next().text('');
    }

    if(FORM_DATA.get('mobile').length < 10 || FORM_DATA.get('mobile').length > 10){
      FORM.find('[name=mobile]').parent().parent().find('.alert-error').text('invalid mobile number');
      errorCounter++;
    }else{
      FORM.find('[name=mobile]').parent().parent().find('.alert-error').text('');
    }

    if(errorCounter === 0){
      SUBMIT_BUTTON.prop('disabled', true);
      SUBMIT_BUTTON.html(`<i class="fas fa-circle-notch fa-spin"></i> Submitting.....`);
      axios.post(HOST+ API_PATH+'/profile-enquiry', FORM_DATA).then(res => {
        FORM.trigger("reset");
        FORM.find('.alert-msg').text(res.data.msg);
        SUBMIT_BUTTON.prop('disabled', false);
        SUBMIT_BUTTON.html(`Send Message <i class="fa fa-paper-plane"></i>`);
        console.log(res);
      }).catch(err => {
        console.log(err);
        SUBMIT_BUTTON.prop('disabled', false);
        SUBMIT_BUTTON.html(`Send Message <i class="fa fa-paper-plane"></i>`);
      });
    }else{

    }

  });

  /**
   * add blur effect on every single element inside this
   * class except login message
   */
  if($('body').find('.user-not-logged-in')){
    $('.user-not-logged-in>*').not('.web-login-message1').css('filter', 'blur(4px)');
  }

  //========================== reviews =====================================
  /**
   * submit review
   */
  $('#submitReview').on('click', function(e){
    const FORM_BUTTON = $(this);
    let formData = new FormData();
    const TYPE = $('#type');
    const TYPE_ID = $('#typeId');
    const REVIEW_DESCRIPTION = $('#reviewDescription');
    let REVIEW_DESCRIPTION_VAL = REVIEW_DESCRIPTION.val();
    const RATING = parseInt($('#currentRating').find('[aria-valuenow]').attr('aria-valuenow'));
    const TITLE  = $('#reviewTitle');

    let filter = new Filter();

    if(RATING < .5){
      $('#scoreErrorMsg').remove();
      FORM_BUTTON.before('<span class="d-block text-danger mt-3 mb-1" id="scoreErrorMsg">Rating is required.</span>');
      removeElementByTimeInSeconds('#scoreErrorMsg', 2000);
      return false;
    }

    formData.append('type', TYPE.val());
    formData.append('type_id', TYPE_ID.val());

    if(REVIEW_DESCRIPTION_VAL.length){
      REVIEW_DESCRIPTION_VAL = filter.clean(REVIEW_DESCRIPTION.val());
    }

    formData.append('description', REVIEW_DESCRIPTION_VAL);
    formData.append('score', RATING);

    FORM_BUTTON.html('<i class="fas fa-circle-notch fa-spin"></i> Submitting').prop('disabled', true);

    //  formData.append('title', TITLE.val());
    axios.post(HOST+ API_PATH+'/parent/submit-review', formData).then(res => {
      FORM_BUTTON.after(`<span class="d-block text-success mt-3 mb-1" id="scoreSuccessMsg">${res.data.msg}</span>`);
      REVIEW_DESCRIPTION.val('');
      // for resetting reviews
      $('.submit-review-wrapper').find('.rateit-selected').css('width', 0);
      $('#currentRating').find('[aria-valuenow]').attr('aria-valuenow', 0)

      FORM_BUTTON.html('Submit Review').prop('disabled', false);
      toastr.success(`${res.data.msg}`, '')
      removeElementByTimeInSeconds('#scoreSuccessMsg', 2000);
    }).catch(err => {
      console.log(err);
      toastr.error(`${err.response.data.msg}`, '');
      FORM_BUTTON.before(`<span class="d-block text-danger mt-3 mb-1" id="scoreErrorMsg">Login Required!!</span>`);
      removeElementByTimeInSeconds('#scoreErrorMsg', 2000);
      FORM_BUTTON.text('Submit Review').prop('disabled', false);
    })
  });

  /**
   * review description word counter
   */
  $('#reviewDescription').on('keyup', function () {
    let reviewDescription = $(this);
    let reviewDescriptionValue = reviewDescription.val();

    let max = 500;
    let len = reviewDescriptionValue.length;
    if (len >= max) {
      $('#reviewWordCounter').text(' you have reached the limit');
    } else {
      let char = max - len;
      $('#reviewWordCounter').text(char + ' characters left');
    }
  });

  /**
   * smooth scroll when review hash exists in url
   */
  if((location.hash).includes('review')){
    const hashId = location.hash;
    smoothScroll(hashId, 1000, 110);
  }

  //========================== /reviews =====================================

  /**
   * submit contact form
   */
  $('#contactForm').on('submit', function(e){
    const FORM = $(this);
    const SUBMIT_BUTTON = FORM.find('[type="submit"]');
    e.preventDefault();
    const FORM_DATA = new FormData(this);

    FORM.next('.res-info').remove();
    SUBMIT_BUTTON.prop('disabled', true);
    SUBMIT_BUTTON.html(`<i class="fas fa-circle-notch fa-spin"></i> Submitting.....`);
    FORM_DATA.append('country_code', FORM.find('.iti__selected-dial-code').text());
    FORM_DATA.append('type', 'CONTACT');


    axios.post(HOST+ API_PATH+'/contact-enquiry', FORM_DATA).then((res) => {
      SUBMIT_BUTTON.text('Submit Message');
      SUBMIT_BUTTON.prop('disabled', false);
      // FORM[0].trigger('reset');
      toastr.success(`${res.data.msg}`, '');
      window.location.reload();
      // FORM.after(`<span class="d-block text-success">${res.data.msg}</span>`);
    }).catch((error) => {
      // FORM.after(`<span class="d-block text-danger res-info">${error.response.msg}</span>`);
      SUBMIT_BUTTON.prop('disabled', false);
      SUBMIT_BUTTON.text('Submit Message');
    });

  });
  $('#callbackForm').on('submit', function(e){
    const FORM = $(this);
    const SUBMIT_BUTTON = FORM.find('[type="submit"]');
    e.preventDefault();
    const FORM_DATA = new FormData(this);

    FORM.next('.res-info').remove();
    SUBMIT_BUTTON.prop('disabled', true);
    SUBMIT_BUTTON.html(`<i class="fas fa-circle-notch fa-spin"></i> Submitting.....`);
    FORM_DATA.append('country_code', FORM.find('.iti__selected-dial-code').text());
    FORM_DATA.append('type', 'CALLBACK');


    axios.post(HOST+ API_PATH+'/contact-enquiry', FORM_DATA).then((res) => {
      SUBMIT_BUTTON.text('Submit Message');
      SUBMIT_BUTTON.prop('disabled', false);
      // FORM[0].trigger('reset');
      toastr.success(`${res.data.msg}`, '');
      // FORM.after(`<span class="d-block text-success">${res.data.msg}</span>`);
    }).catch((error) => {
      // FORM.after(`<span class="d-block text-danger res-info">${error.response.msg}</span>`);
      SUBMIT_BUTTON.prop('disabled', false);
      SUBMIT_BUTTON.text('Submit Message');
    });
  });

  if($(".duration_range_slider").length){
    $(".duration_range_slider").ionRangeSlider({skin: "round", type: "double", grid: true, postfix: " Days"});
    $(".fees_range_slider").ionRangeSlider({skin: "round", type: "double", grid: true, prefix: "₹"});
  }

  /**
   * update search request after every input on search page
   */
  let searchForm = $('#searchForm');
  if(searchForm.length){
    searchForm.find('input').on('change', function(e){
      searchForm.trigger('submit');
    });


  }

  /**
   * add actions on web login modal hide
   */
  $('#webLoginModal').on('hidden.bs.modal', function(e){
    if(localStorage.getItem('parent_info') !== null){  // when user is logged in
      if(localStorage.getItem('enrollnow') !== null){ // when user click on enroll now button
        $('.courseEnrollNow.demoRequesting').trigger('submit');
      }

    }
  });


  /**
   * call button to show login modal
   */
  $('.btn-callback').on('click', function(e){
    if(localStorage.getItem('parent_info') === null){ // when user is logged in
      $('#webLoginModal').modal('show');
    } else {
      window.open(`tel:${CALLBACK_NUMBER}`, '_self');
    }
  });

  /**
   * request a demo for any course program
   */
  $('.courseEnrollNow').on('submit', function(e){
    e.preventDefault();
    const FORM  = $(this);
    const SUBMIT_BUTTON = FORM.find('[type=submit]');
    const FORM_DATA = new FormData();
    FORM_DATA.append('course_program_id', FORM.data('courseprogramid'));
    FORM.addClass('demoRequesting');
    if(localStorage.getItem('parent_info') === null) {
      localStorage.setItem('enrollnow', true);
      $('#webLoginModal').modal('show');
      return false;
    }

    SUBMIT_BUTTON.prop('disabled', true);
    SUBMIT_BUTTON.html(`<i class="fas fa-circle-notch fa-spin"></i> Requesting.....`);

    axios.post(HOST + API_PATH+'/enroll-now', FORM_DATA).then(res => {
      SUBMIT_BUTTON.text('Demo Request Sent');
      (async () => {
        await updateProgramApplications();
      })();

    }).catch(err => {
      if(err.response.data.msg === 'already enrolled'){
        SUBMIT_BUTTON.text('Already Requested');
      }else{
        SUBMIT_BUTTON.prop('disabled', false);
        SUBMIT_BUTTON.text('Book a Demo');
      }
      console.log(err.response.data);
    })


  });

  /**
   * Show assistant on page scroll
   */
  setTimeout(function(){
    if(sessionStorage.getItem('hideAssistant') === null && !localStorage.getItem('parent_info')) {
      const ASSIST_MODAL = $('#assistModal');
      const LOGIN_MODAL = $('#webLoginModal');
      if (!ASSIST_MODAL.is(':visible') && !LOGIN_MODAL.is(':visible')) {
        ASSIST_MODAL.modal('show');
      }
    }
  }, 5000);

  /**
   * Set session value when hide assistant modal
   */
  $('#assistModal').on('hidden.bs.modal', function(){
    sessionStorage.setItem('hideAssistant', true);
  });

});

(async () => {
  await updateProgramApplications();
})();

/**
 * Enter only number in input
 */
$('.number-only').on('keypress', function(e){
  if(isNaN(e.key)){
    return false;
  }
});

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
function validateEmail(email) {
  let regExp = /\S+@\S+\.\S+/;
  return regExp.test(email);
}

/**
 *
 * @param element
 * @param time Seconds
 */
function removeElementByTimeInSeconds(element, time = 2000){
  setTimeout(() => {
    $(element).remove();
  }, time);
}

/**
 * smooth scroll
 * @param hashId
 * @param time
 * @param offset
 */
function smoothScroll(hashId, time = 2000, offset = 0){
  $('html,body').animate({
    'scrollTop':   $(hashId).offset().top - offset
  }, time);
}

async function getProgramApplications()
{
  return await axios.get(`${HOST+ API_PATH}/get-program-applications`);
}

async function updateProgramApplications()
{
  let getProgramApplicationsResponse = false;
  if(localStorage.getItem('parent_info')){
    getProgramApplicationsResponse = await getProgramApplications();
    if(getProgramApplicationsResponse.data.length){
      let coursePrograms = $('.courseEnrollNow');
      if(coursePrograms.length > 1){
        coursePrograms.each(function(i, courseProgram){
          courseProgram = $(courseProgram);
          let courseProgramId = courseProgram.data('courseprogramid');
          if(!courseProgram.hasClass('demoRequesting')){
            let courseProgramIdExist = _.find(getProgramApplicationsResponse.data, function(o) { return o.course_program_id === courseProgramId; });
            if(_.size(courseProgramIdExist)){
              courseProgram.find('fieldset').prop('disabled', true);
              courseProgram.find('.btn').text('Demo Requested');
            }
          }
        });
      }
    }

  }
  return getProgramApplicationsResponse;
}
